var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Close = forwardRef(function (props, ref) { return (_jsxs(StyledIcon, __assign({ ref: ref, viewBox: "0 0 20 20", a11yTitle: "Close" }, props, { children: [_jsx("path", { d: "M2.27293 15.1996L15.5437 1.92883C16.5391 0.93352 17.7474 0.814811 18.5647 1.63206C19.3819 2.44931 19.2632 3.65768 18.2679 4.65299L4.99709 17.9238C4.00178 18.9191 2.79341 19.0378 1.97616 18.2206C1.15891 17.4033 1.27762 16.195 2.27293 15.1996Z", fill: "#000" }), _jsx("path", { d: "M15.5434 17.9238L2.27258 4.65303C1.27727 3.65772 1.15856 2.44935 1.97581 1.6321C2.79306 0.814852 4.00143 0.93356 4.99674 1.92887L18.2676 15.1997C19.2629 16.195 19.3816 17.4034 18.5643 18.2206C17.7471 19.0379 16.5387 18.9192 15.5434 17.9238Z", fill: "#000" })] }))); });
//# sourceMappingURL=Close.js.map